import { render } from "./index.vue?vue&type=template&id=ebb8b9e4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=ebb8b9e4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ebb8b9e4"

export default script